import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import {useParams} from 'react-router-dom';
import {Translate} from 'react-redux-i18n';

import {useStateHook} from 'front-onceforall-core/dist/utils/customHooks';
import {addError} from '../../../actions/snackbars';
import {captureError} from '../../../utils/log';

import {getMandateDetails} from './utils';
import MandateDetailsView from './MandateDetailsView';

function MandateDetailsContainer({isCollectionMandate}) {
  const {mandateId} = useParams();
  const dispatch = useDispatch();
  const [state, setState] = useStateHook({
    details: undefined,
    loading: true
  });

  React.useEffect(() => {
    getMandateDetails(mandateId, isCollectionMandate)
      .then(details => {
        setState({details});
      })
      .catch(error => {
        captureError('Error while getting mandate details', error);
        dispatch(addError(<Translate value="error.generic"/>));
      })
      .finally(() => {
        setState({loading: false});
      });
  }, []);

  return (
    <MandateDetailsView
      details={state.details}
      loading={state.loading}
      isCollectionMandate={isCollectionMandate}
    />
  );
}

MandateDetailsContainer.propTypes = {
  isCollectionMandate: PropTypes.bool.isRequired
};

export default MandateDetailsContainer;
